import { createBrowserHistory as createHistory, Location } from 'history';

import analytics from 'helpers/analytics';
import { extractPrefix, localizeWithCurrentUrl } from 'helpers/locales';

const $rootNode = document.getElementById('root');
const history = createHistory();

let canGoBack = false;

export let prevLocation: Location | null = null;
export let currentLocation = history.location;

const WITHOUT_SCROLL_TO_TOP = /(sign-in|sign-up|details)/g;

history.listen((h) => {
  prevLocation = currentLocation;
  currentLocation = history.location;

  if (!canGoBack) {
    canGoBack = true;
  }

  if (history.location.pathname.match(/(details|player)/g) === null) {
    analytics.page(history.location.pathname); // TODO use current page title here
  }

  if (
    history.location.pathname.match(WITHOUT_SCROLL_TO_TOP) === null &&
    prevLocation.pathname.match(WITHOUT_SCROLL_TO_TOP) === null
  ) {
    window.scrollTo(0, 0);
    $rootNode &&
      typeof $rootNode.scrollTo === 'function' &&
      $rootNode.scrollTo(0, 0);
  }
});

// fallback is used when there is no previous route (on initial page render)
export function goBack({ fallback = '/' } = {}) {
  const prefix = extractPrefix(window.location.pathname);

  if (canGoBack) {
    history.goBack();
    return;
  }

  const localizedFallback = localizeWithCurrentUrl(fallback);
  const localizedExploreFallback = localizeWithCurrentUrl('explore');

  if (fallback === prefix) {
    window.location.href = `https://www.femtasy.com${prefix}`;
    return;
  }

  /*
   * If we reload the page on a story details page,
   * or we open a link directly with a story details page,
   * the fallback will be /locale/stories, giving a 404
   * when we try to go back.
   * To avoid this, we redirect to /locale/explore.
   */
  if (localizedFallback.match(localizeWithCurrentUrl('stories')) !== null) {
    history.push(localizedExploreFallback);
  } else {
    history.push(localizedFallback);
  }
}

export default history;
